/**
 * Execute the provided promise, with a hard timeout, so that after the provided ms
 * it will no longer execute.
 */
export function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
    const timeout = new Promise<never>((_, reject) =>
        setTimeout(() => reject(new Error(`Timeout after ${ms}ms`)), ms),
    )

    return Promise.race([promise, timeout])
}
